export default __webpack_public_path__ + "static/media/Hair_18_F_C5.a7a3567c.svg";